import { useEffect, useState } from "react"

import { Card, Layout, Spin, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useNavigate } from "react-router-dom"

import ButtonComponent from "../Components/Button"
import RestorePasswordForm from "../Components/Forms/RestorePasswordForm"
import LoginHeader from "../Components/LoginHeader"
import PrivacyPolicy from "../Components/PrivacyPolicy"
import AuthActions from "./LoginPage/reducer"

const { Text } = Typography

function RestorePasswordPage(props) {
  const { error, fetching } = props

  const navigate = useNavigate()
  const { t } = useTranslation()

  const [firstLoading, setFirstLoading] = useState(true)

  function handleSubmit(data) {
    props.checkPassword(data.email)
  }

  useEffect(() => {
    document.title = "Forgot Password - Chargeback"
    if (firstLoading) {
      props.resetError()
      setFirstLoading(false)
    }
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [])

  useEffect(() => {
    if (error) props.resetError()
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [error])

  return (
    <Layout>
      <Spin size="large" spinning={fetching}>
        <div className="login-row">
          <LoginHeader />
          <div className="login-content">
            <div className="content-main sign-up">
              <Card className="login-card">
                <h2 className="card-title">{t("Reset Password")}</h2>
                <h4 className="card-subtitle-signup" style={{ margin: 0 }}>
                  {t("Enter your email address and we'll send you a link to reset your password.")}
                </h4>
                <RestorePasswordForm
                  onSubmit={handleSubmit}
                  error={!firstLoading && error?.message}
                >
                  <ButtonComponent
                    type="text"
                    size="large"
                    onClick={() => navigate("/login")}
                    style={{ marginTop: "16px" }}
                    block
                  >
                    <Text type="secondary">{t("Know your password?")} </Text>
                    <Text type="link" className="text-link">
                      {t("Sign in")}
                    </Text>
                  </ButtonComponent>
                </RestorePasswordForm>
              </Card>
              <PrivacyPolicy />
            </div>
          </div>
        </div>
      </Spin>
    </Layout>
  )
}

const mapStateToProps = (state) => {
  return {
    error: state.auth.error,
    fetching: state.auth.fetching
  }
}

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  checkPassword: (email) => dispatch(AuthActions.checkPasswordRequest(email)),
  resetError: () => dispatch(AuthActions.authErrorReset())
})

export default connect(mapStateToProps, mapDispatchToProps)(RestorePasswordPage)
